import {
  Activity, BookOpen, Boxes, Container, Database, FileClock, KeyRound, Layers, LayoutDashboard,
  Network, PackageOpen, Server, Settings, Users, type LucideIcon,
} from 'lucide-react';

export const navIcons: Record<string, LucideIcon> = {
  dashboard: LayoutDashboard, apps: Boxes, catalog: PackageOpen, users: Users,
  instances: Server, endpoints: Network, containers: Container, stacks: Layers, volumes: Database,
  docs: BookOpen, keys: KeyRound, audit: FileClock, settings: Settings,
};
export const FallbackIcon = Activity;
